module.exports = {"540426100":"朗镇","540426101":"仲达镇","540426102":"洞嘎镇","540426200":"拉多乡","540426201":"金东乡","540426202":"登木乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540426.json
// module id = 2722
// module chunks = 0